import cls from "classnames";
import { useRef, useState } from "react";
import useScrollHeight from "@qoohoo/common/hooks/useScrollHeight";
import { isValidUsername } from "@qoohoo/common/utils/string";
import UserAvatar from "@qoohoo/common/components/UserAvatar";

export default function MemberHero({ userData }) {
  const [seeMore, setSeeMore] = useState(false);
  const descRef = useRef(<p></p>);
  const isVisible = useScrollHeight(descRef);
  const userName = isValidUsername(userData?.username)
    ? userData?.username
    : "qoohoo member";
  const userNameOrFullname = userData?.fullname || userName;
  const userFullname = userData?.fullname || "qoohoo member";

  return (
    <section className="mt-14 lg:mt-[4.5rem] mx-auto">
      <div className="flex flex-col justify-center lg:flex-row lg:items-start sm:max-w-max sm:mx-auto">
        <div className="flex pr-3 pl-7 lg:px-0">
          <div className="lg:mt-2 mr-6 lg:mr-[72px]">
            <div className="w-[120px] h-[136px] lg:w-[225px] lg:h-[253px] overflow-hidden rounded-2xl flex justify-center items-center font-bold md:text-7xl text-4xl bg-[#fff] bg-opacity-[0.03]">
              <UserAvatar
                avatarUrl={userData.avatar_url}
                alt={userNameOrFullname}
                userName={userNameOrFullname}
                className="h-full"
              />
            </div>
          </div>
          <div className="flex justify-between items-center sm:space-x-11 lg:hidden max-w-[152px] w-full">
            <div className="text-center">
              <h2 className="text-xl font-medium leading-normal lg:text-2xl lg:font-semibold font-inter lg:font-nunito">
                {userData?.user_insights?.total_number_of_networked_members}
              </h2>
              <p className="text-[13px] lg:text-sm mt-1">in network</p>
            </div>
            <div className="text-center">
              <h2 className="text-xl font-medium leading-normal lg:text-2xl lg:font-semibold font-inter lg:font-nunito">
                {userData.channel_count ||
                  userData?.user_insights?.total_number_of_communities_joined}
              </h2>
              <p className="text-[13px] lg:text-sm mt-1">channels</p>
            </div>
          </div>
        </div>
        <div className="max-w-[424px] pl-5 pr-8 mt-10 lg:mt-0 lg:px-0">
          <p className="text-[#DCEB82] text-sm lg:text-lg font-medium font-inter">
            Hey, I&apos;m
          </p>
          <div className="flex items-center mt-2 lg:mt-4">
            <h1 className="text-[32px] lg:text-[40px] leading-[40px] lg:leading-[48px] font-semibold font-inter truncate max-w-full">
              {userFullname}
            </h1>
          </div>
          <div className="items-center hidden mt-8 lg:flex">
            <div className="mr-12">
              <h2 className="text-2xl font-semibold leading-normal">
                {userData?.user_insights?.total_number_of_networked_members}
              </h2>
              <p className="mt-1 text-sm">in network</p>
            </div>
            <div>
              <h2 className="text-2xl font-semibold leading-normal">
                {userData.channel_count ||
                  userData?.user_insights?.total_number_of_communities_joined}
              </h2>
              <p className="mt-1 text-sm">channels</p>
            </div>
          </div>
          <p
            ref={descRef}
            className={cls(
              "mt-6 max-w-[422px] text-[13px] lg:text-sm leading-normal whitespace-pre-wrap",
              seeMore ? "line-clamp-none" : "line-clamp-6"
            )}
          >
            {userData.bio}
          </p>
          {isVisible && (
            <button
              className="text-sm font-semibold lg:mt-1 lg:font-bold font-nunito hover:opacity-90"
              onClick={() => setSeeMore(!seeMore)}
            >
              {seeMore ? "see less" : "see more"}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
